<h5 class="font24 font500">Promoted Categories</h5>
<div class="row">
  <div
    *ngFor="let cat of promotedCategories"
    class="col-lg-6 d-flex align-items-stretch mt-3"
  >
    <div class="card border-0">
      <img [src]="cat.ImageURL" class="card-img w-100 border-0" alt="..." />
      <div class="card-img-overlay border-0">
        <div class="row h-100 d-flex align-items-end">
          <div class="col-md-12 text-white p-4">
            <h5 class="font24">{{ cat.Header }}</h5>
            <div class="">
              <button
                *ngIf="cat.Tag1"
                type="button"
                class="btn btn-sm btn-outline-light me-1"
              >
                {{ cat.Tag1 }}
              </button>
              <button
                *ngIf="cat.Tag2"
                type="button"
                class="btn btn-sm btn-outline-light me-1"
              >
                {{ cat.Tag2 }}
              </button>
              <button
                *ngIf="cat.Tag3"
                type="button"
                class="btn btn-sm btn-outline-light me-1"
              >
                {{ cat.Tag3 }}
              </button>
              <button
                *ngIf="cat.Tag4"
                type="button"
                class="btn btn-sm btn-outline-light me-1"
              >
                {{ cat.Tag4 }}
              </button>
              <button
                *ngIf="cat.Tag5"
                type="button"
                class="btn btn-sm btn-outline-light me-1"
              >
                {{ cat.Tag5 }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <a
        href="javascript:void(0)"
        (click)="navigate(cat.RedirectURL)"
        class="stretched-link"
      ></a>
    </div>
  </div>
</div>
